/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/ActivityBlockedView.scss';

type Props = {
  isSignedIn: boolean,
  title: string,
  subtext: string,
};

function ActivityBlockedView(props: Props) {
  return (
    <div className="ActivityBlockedView">
      <TitleHeader
        subtle
        size="xlarge"
        title={props.title}
        subtext={props.subtext}
      />

      {/* href to perform a full page reload, so that webview's can catch the change */}
      {props.isSignedIn ?
        <Button href="/classes">Continue to Remind</Button> :
        <Button href="/log_in">Log in</Button>
      }
    </div>
  );
}

export default ActivityBlockedView;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityBlockedView.jsx